import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const images = [
  "/hotel1.jpg", "/hotel2.jpg", "/hotel3.jpg", "/hotel4.jpg",
  "/hotel5.jpg", "/hotel6.jpg", "/hotel7.jpg", "/hotel8.jpg",
];

const HotelForm = () => {
  const [formData, setFormData] = useState({
    nombre: "",
    email: "",
    telefono: "",
    fecha_in: "2025-10-08",
    fecha_out: "2025-10-12",
  });

  const [successMsg, setSuccessMsg] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("/reservar.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        setSuccessMsg("Gracias por tu reserva. Nuestro equipo se pondrá en contacto para confirmar.");
        setFormData({
          nombre: "",
          email: "",
          telefono: "",
          fecha_in: "2025-10-08",
          fecha_out: "2025-10-12",
        });
      } else {
        setSuccessMsg("Hubo un problema al enviar la reserva. Intentá nuevamente.");
      }
    } catch (err) {
      console.error(err);
      setSuccessMsg("Error al conectar con el servidor. Verificá tu conexión.");
    }
  };

  return (
    <div className="flex flex-col items-center w-full max-w-3xl mx-auto p-4 space-y-6">
      {/* Header Hotel Info */}
      <div className="w-full space-y-4">
        <h1 className="text-3xl font-bold text-center">Design Suites Buenos Aires</h1>
        <p className="text-center text-gray-700 text-2xl sm:text-3xl font-semibold leading-snug">
          Alojamiento exclusivo para participantes del<br />
          XXI UIP WORLD CONGRESS Buenos Aires 2025<br />
          del 6 al 11 de Octubre en Buenos Aires.
        </p>

        {/* Swiper Carousel */}
        <Swiper
          modules={[Pagination, Autoplay]}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          spaceBetween={10}
          slidesPerView={1}
          className="rounded-2xl shadow-lg"
        >
          {images.map((src, idx) => (
            <SwiperSlide key={idx}>
              <img
                src={src}
                alt={`Foto ${idx}`}
                className="w-full h-64 object-cover rounded-xl"
              />
            </SwiperSlide>
          ))}
        </Swiper>
        
        {/* Sección del Mapa */}
        <div className="mt-8 w-full bg-teal-50 p-4 rounded-2xl shadow-inner">
          <h3 className="text-lg font-semibold text-teal-800 mb-2 text-center">
            Cercanía entre hoteles
          </h3>
          <iframe 
            title="Ruta a pie entre hoteles"
            src="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d1157.8704384794917!2d-58.37993006451713!3d-34.611652800426306!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e2!4m5!1s0x95bccad1375b1183%3A0x71f4bbc2d5a872f6!2sDesign%20Suites%20Buenos%20Aires%2C%20Tacuar%C3%AD%2C%20Buenos%20Aires!3m2!1d-34.6112128!2d-58.379180399999996!4m5!1s0x95bcbd811b6fbcdd%3A0xd531600513a698cd!2sInterContinental%20Buenos%20Aires%20by%20IHG%2C%20Moreno%2C%20Buenos%20Aires!3m2!1d-34.611415199999996!2d-58.378059799999996!5e0!3m2!1ses-419!2sar!4v1744164283111!5m2!1ses-419!2sar"
            width="100%"
            height="265"
            className="rounded-xl shadow-md border"
            allowFullScreen 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
          />
          <p className="text-sm text-gray-700 text-center mt-3">
            🗺️ El <strong>Hotel Intercontinental</strong> (sede del Congreso) se encuentra a aproximadamente <strong>100 metros</strong> del <strong>Hotel Design Suites</strong>. Es posible caminar entre ambos hoteles utilizando el pasaje peatonal que conecta Tacuarí con Moreno, accediendo al Intercontinental por su entrada trasera.
          </p>
        </div>
      </div>

      {/* Booking Form */}
      <form
        onSubmit={handleSubmit}
        className="w-full bg-white p-6 rounded-2xl shadow-xl space-y-4"
      >
        <h2 className="text-xl font-semibold mb-2">Reserva tu estadía</h2>

        <input
          placeholder="Nombre completo"
          type="text"
          name="nombre"
          required
          value={formData.nombre}
          onChange={handleChange}
          className="w-full p-2 border rounded-lg"
        />
        <input
          placeholder="Correo electrónico"
          type="email"
          name="email"
          required
          value={formData.email}
          onChange={handleChange}
          className="w-full p-2 border rounded-lg"
        />
        <input
          placeholder="Teléfono o WhatsApp"
          type="tel"
          name="telefono"
          required
          value={formData.telefono}
          onChange={handleChange}
          className="w-full p-2 border rounded-lg"
        />
        <div className="flex flex-col sm:flex-row gap-4">
          <input
            placeholder="Fecha de ingreso"
            type="date"
            name="fecha_in"
            required
            value={formData.fecha_in}
            onChange={handleChange}
            className="w-full p-2 border rounded-lg"
          />
          <input
            placeholder="Fecha de salida"
            type="date"
            name="fecha_out"
            required
            value={formData.fecha_out}
            onChange={handleChange}
            className="w-full p-2 border rounded-lg"
          />
        </div>

        <div className="bg-teal-50 border border-teal-200 p-4 rounded-xl text-sm text-teal-900 space-y-1">
          <p>💰 <strong>Tarifa:</strong> USD 165 por noche (habitación single o doble).</p>
          <p>🍽️ <strong>Incluye desayuno buffet.</strong></p>
          <p>🧾 <strong>Residentes argentinos:</strong> deben adicionar IVA según normativa vigente.</p>
        </div>

        <button
          type="submit"
          className="w-full bg-teal-700 text-white py-2 rounded-lg hover:bg-teal-800 transition"
        >
          Reservar
        </button>

        {successMsg && (
          <p className="text-center text-green-600 font-medium mt-4">{successMsg}</p>
        )}
      </form>
    </div>
  );
};

export default HotelForm;
